import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  focusSearch(event) {
    event.preventDefault()
    
    const searchField = document.querySelector('#jobs-search')
    if (searchField) {
      // Smooth scroll to search field
      searchField.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      
      // Focus the search field after a short delay to ensure scroll is complete
      setTimeout(() => {
        searchField.focus()
        // Select any existing text if present
        if (searchField.value) {
          searchField.select()
        }
      }, 300)
    }
  }
}

